const passwordManagers = {
  slug: 'password-managers',
  title: 'Password managers: why they matter',
  description:
    'How password managers store unique credentials, resist phishing reuse, and why we recommend 1Password for most people.',
  category: 'digital',
  guideType: 'guide',
  readMinutes: 5,
  partnerTip: 'primary',
  relatedSlugs: ['password-security-basics', 'two-factor-authentication', 'after-a-scam-call'],
  sections: [
    {
      type: 'paragraph',
      text: 'Remembering dozens of unique passwords is unrealistic. Password managers create, store, and fill strong passwords so you only need to protect one master password (plus two-factor authentication on the manager itself).',
    },
    {
      type: 'heading',
      level: 2,
      text: 'What a password manager does',
    },
    {
      type: 'list',
      items: [
        'Generates long random passwords per site',
        'Autofills login forms so you are less tempted to reuse passwords',
        'Alerts you to reused or weak passwords and known breaches',
        'Syncs securely across phone, laptop, and browser',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Free options exist',
    },
    {
      type: 'paragraph',
      text: 'Built-in browser password storage and free tiers from several vendors are better than password reuse. Paid managers add family sharing, advanced breach monitoring, and support.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Why we recommend 1Password',
    },
    {
      type: 'paragraph',
      text: 'We recommend 1Password for its balance of security, ease of use, and family or team features. It helps scam victims recover faster by making unique passwords the default — not an afterthought. WhoDatNumber does not include a signup link here yet; visit 1Password directly when you are ready to choose a manager.',
    },
    {
      type: 'partnerTip',
      partnerId: 'onePassword',
      variant: 'primary',
    },
    {
      type: 'link',
      to: '/learn/two-factor-authentication',
      label: 'Add two-factor authentication next',
    },
  ],
};

export default passwordManagers;

